import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import bannerImg from '../assets/images/banner.png';

const MobilePatrols = () => {
  return (
    <div className="service-detail-page">
      
      {/* INJECTED STYLES FOR MOBILE RESPONSIVENESS */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .service-hero::after {
            display: none !important;
          }

          /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 992px) {
            .service-text-grid { grid-template-columns: 1fr !important; gap: 3rem !important; }
            .process-steps { grid-template-columns: 1fr !important; gap: 2rem !important; }
          }

          @media (max-width: 768px) {
            /* Hero adjustments to prevent overlap with header */
            .service-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
            .service-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
            .service-hero p.subtitle { font-size: 1.1rem !important; }

            /* Enforce container boundaries */
            .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

            /* Spacing fixes */
            .service-main-content { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            .service-process-section { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            
            /* Fix CTA layout overlapping screen edges */
            .sleek-cta-banner-override { flex-direction: column !important; text-align: center !important; padding: 3rem 1.5rem !important; }
            .sleek-cta-banner-override > div { min-width: 100% !important; text-align: center !important; }
            .sleek-cta-banner-override p { margin: 0 auto !important; }
          }
        `}
      </style>

      {/* 1. UNIFIED HERO */}
      <section className="service-hero">
        <div className="container text-center">
          <h1>Mobile Patrols</h1>
          <p className="subtitle">
            Flexible, highly visible security coverage across multiple sites.
          </p>
        </div>
      </section>

      {/* 2. MAIN CONTENT & SIDEBAR */}
      <section className="service-main-content container" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="service-text-grid">
          
          {/* Left Column: Description */}
          <div className="service-description">
            <h2 style={{ marginTop: 0 }}>Dynamic & Deterrent Security</h2>
            <p>
              When continuous static guarding is not a requirement, your premises still need protection out of hours. Our mobile patrol services provide a flexible, highly visible security presence across your sites. Through both scheduled and randomised responsive patrols, our teams effectively deter unwanted activity, identify risks early, and ensure your premises remain fully secure.
            </p>
            <p>
              Utilising highly visible, branded patrol vehicles and GPS-tracked routes, our SIA-licensed officers conduct thorough perimeter checks, internal inspections, and out-of-hours locking and unlocking procedures. This dynamic approach ensures that potential intruders can never predict our movements, providing an incredibly effective deterrent against theft, vandalism, and unauthorized access.
            </p>

            <h3>Core Capabilities</h3>
            <ul className="custom-bullet-list">
              <li>Highly visible, branded patrol vehicles providing a strong visual deterrent.</li>
              <li>Randomised and scheduled site inspections to prevent predictable patterns.</li>
              <li>Thorough perimeter checks, window/door checks, and internal sweeps.</li>
              <li>Secure out-of-hours locking and unlocking of commercial premises.</li>
              <li>Real-time reporting and fully GPS-tracked patrol routes for complete transparency.</li>
            </ul>
          </div>

          {/* Right Column: Premium Contact Sidebar */}
          <aside className="service-sidebar" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '3rem 2.5rem', borderRadius: '12px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)', height: 'fit-content', border: 'none' }}>
            <h3 style={{ color: 'var(--color-white)', marginBottom: '1rem', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '1rem' }}>Secure Your Perimeters</h3>
            <p style={{ fontSize: '0.95rem', color: 'var(--color-secondary-light)', lineHeight: '1.6', marginBottom: '2rem' }}>
              Speak directly with our operations team to set up flexible, tracked mobile patrols for your business.
            </p>
            <div className="sidebar-contact" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
              <span style={{ fontSize: '0.85rem', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-grey)', display: 'block', marginBottom: '0.5rem' }}>24/7 Operations Desk</span>
              <div className="phone-number" style={{ fontFamily: 'var(--font-heading)', fontSize: '1.8rem', fontWeight: '800', color: 'var(--color-white)', margin: '0 0 2rem 0' }}>01270 446302</div>
              <Link to="/contact" className="btn btn-pill w-100 text-center" style={{ backgroundColor: 'var(--color-white)', color: 'var(--color-primary-navy)', fontWeight: '700', padding: '1rem', fontSize: '0.95rem', boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }}>
                Contact Us
              </Link>
            </div>
          </aside>

        </div>
      </section>

      {/* 3. PROCESS SECTION */}
      <section className="service-process-section bg-navy" style={{ paddingTop: '6rem', paddingBottom: '8rem' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2 style={{ color: 'var(--color-white)' }}>Our Patrol Protocol</h2>
          </div>
          <div className="process-steps">
            <div className="step-card">
              <h4>Route Planning</h4>
              <p>We design randomized and structured patrol routes customized to your specific site vulnerabilities and operating hours.</p>
            </div>
            <div className="step-card">
              <h4>Active Patrolling</h4>
              <p>SIA-licensed officers execute thorough perimeter and internal checks using highly visible, branded response vehicles.</p>
            </div>
            <div className="step-card">
              <h4>Real-Time Reporting</h4>
              <p>All activities, checks, and potential incidents are logged digitally, providing you with transparent, verifiable updates.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. SLEEK FLOATING CTA BANNER */}
      <section style={{ backgroundColor: 'var(--color-white)', paddingTop: '4rem', paddingBottom: '6rem' }}>
        <div className="container">
          <div 
            className="sleek-cta-banner-override"
            style={{ 
            backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})`,
            borderRadius: '16px',
            padding: '3rem 4rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            gap: '2rem',
            flexWrap: 'wrap',
            position: 'relative',
            overflow: 'hidden'
          }}>

            <div style={{ textAlign: 'left', flex: '1', position: 'relative', zIndex: 2, minWidth: '300px' }}>
              <h2 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: '2.1rem', letterSpacing: '-0.5px' }}>Uncompromising Security Solutions</h2>
              <p style={{ color: 'var(--color-secondary-light)', fontSize: '1rem', margin: 0, maxWidth: '600px', lineHeight: '1.6' }}>
                Discover how our highly trained personnel can deliver bespoke security solutions tailored to your organisation.
              </p>
            </div>
            
            <div style={{ position: 'relative', zIndex: 2, flexShrink: 0 }}>
              <Link to="/contact" className="btn btn-pill" style={{ 
                backgroundColor: 'var(--color-white)', 
                color: 'var(--color-primary-navy)', 
                fontWeight: '700', 
                padding: '1rem 2.5rem', 
                fontSize: '0.95rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
              }}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default MobilePatrols;